var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTraingleOrange = function SvgAlertTraingleOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC7351",
    fillRule: "evenodd",
    d: "M6.239 2.242a1.78 1.78 0 0 1 2.392.627l.002.003 5.02 8.379.004.008a1.777 1.777 0 0 1-1.52 2.667H2.085a1.778 1.778 0 0 1-1.52-2.667l.005-.008 5.021-8.382c.159-.261.382-.477.648-.627m.872.956a.59.59 0 0 0-.506.284L1.59 11.855a.593.593 0 0 0 .506.886h10.03a.592.592 0 0 0 .507-.886L7.618 3.484v-.002a.59.59 0 0 0-.507-.284m0 2.432c.327 0 .593.265.593.592v2.37a.593.593 0 1 1-1.185 0v-2.37c0-.327.265-.592.592-.592m-.592 5.333c0-.327.265-.593.592-.593h.006a.593.593 0 1 1 0 1.186h-.006a.593.593 0 0 1-.592-.593",
    clipRule: "evenodd"
  })));
};
export default SvgAlertTraingleOrange;